import pure from '@tekion/tekion-base/utils/pure';
import Label from './Label';
export default pure(Label);